import React from "react";
import AppSidebar from "../components/appSidebar";
import AppHeader from "../components/appHeader";
import AppContent from "../components/appContent";

/**
 * @function MainLayout
 * @description for MainLayout
 * @returns JSX for MainLayout
 */

const MainLayout = () => {
  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div className="body flex-grow-1">
          <AppContent />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
